<div class="master-modal reviepw_items_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title">Change Order Status</h4>
        <div class="modal_close_btn">
          <span (click)="dialogClose('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <form [formGroup]="changeStatusForm" (ngSubmit)="updateStatus()" class="form-section">
        <!-- Modal content-->
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <!-- Modal-Body -->
            <div class="modal-body">
              <div class="oreder_status_change">
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                  fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
                  <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                    fxFlexFill>
                    <!-- TABS -->
                    <div class="custom-tabs mb-20" >
                      <mat-button-toggle-group [ngClass]="{'errorTabSelect': selectTab === 'null'}"   formControlName="status"
                        class="horizontal-toggle-buttons tabs-button-group">
                        <mat-button-toggle value="APPROVED" *ngIf="['PENDING'].includes(data.status)">
                          <span class="mat-button-content"> Approved </span>
                        </mat-button-toggle>
                        <mat-button-toggle value="SHIPPED" 
                          *ngIf="['APPROVED',  'PARTIALLY_SHIPPED' ].includes(data.status)">
                          <span class="mat-button-content"> Shipped </span>
                        </mat-button-toggle>
                        <mat-button-toggle value="DELIVERED"
                          *ngIf="['PARTIALLY_SHIPPED' , 'SHIPPED'].includes(data.status)">
                          <span class="mat-button-content"> Delivered </span>
                        </mat-button-toggle>
                        <mat-button-toggle value="CANCELLED" *ngIf="['PENDING'].includes(data.status)">
                          <span class="mat-button-content"> Cancelled </span>
                        </mat-button-toggle>
                        <mat-button-toggle value="REFUNDED" *ngIf="['PENDING', 'DELIVERED'].includes(data.status)">
                          <span class="mat-button-content"> Refunded </span>
                        </mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>
                    <!-- Add Invoice -->
                    <ng-container *ngIf="['PARTIALLY_SHIPPED', 'SHIPPED'].includes(status.value)">
                      <div formGroupName="extra">
                        <div class="custom-form-group custom_file_group">
                          <label class="custom-label" for="">Add Invoice<span class="star"
                              style="display: inline-block !important;">*</span></label>
                          <div class="custom-form-control">
                            <mat-button-toggle-group formControlName="type" aria-label="Select Invoice type">
                              <mat-button-toggle value="IMAGE"> Image </mat-button-toggle>
                              <mat-button-toggle value="File"> File </mat-button-toggle>
                            </mat-button-toggle-group>
                            <app-single-file-upload [fileInput]="invoice" [type]="type.value" [allowedTypes]="type.value ==='IMAGE' ? allowedImageTypes : allowedFileTypes"></app-single-file-upload>
                            <mat-error *ngIf="invoice.invalid && ( invoice.dirty || invoice.touched )">
                              <span> Invoice is
                                required</span>
                            </mat-error>
                          </div>
                        </div>
                        <!-- Tracking number-TEXT-AREA-->
                        <div class="custom-form-group">
                          <label class="custom-label fx-display" for="">Tracking Number <span class="star"
                              style="display: inline-block !important;">*</span>
                          </label>
                          <div class="custom-form-control">
                            <mat-form-field appearance="outline">
                              <input matInput formControlName="tracking_number" placeholder="Enter tracking number"
                              (focusout)="trimMe(tracking_number)" />
                              <mat-error
                                *ngIf="tracking_number.invalid && ( tracking_number.dirty || tracking_number.touched )">
                                <span>Tracking number is required </span>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <!-- Tracking link-TEXT-AREA-->
                        <div class="custom-form-group">
                          <label class="custom-label fx-display" for="">Tracking link <span class="star"
                              style="display: inline-block !important;">*</span>
                          </label>
                          <div class="custom-form-control">
                            <mat-form-field appearance="outline">
                              <input matInput formControlName="tracking_link" placeholder="Enter tracking link"
                              (focusout)="trimMe(tracking_link)" />
                              <mat-error *ngIf="tracking_link.invalid &&
                          ( tracking_link.dirty || tracking_link.touched )">
                                <span> Tracking link is required </span>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <!-- Tracking link-TEXT-AREA-->
                        <div class="custom-form-group">
                          <label class="custom-label fx-display" for="">Freight company name <span class="star"
                              style="display: inline-block !important;">*</span>
                          </label>
                          <div class="custom-form-control">
                            <mat-form-field appearance="outline">
                              <input matInput formControlName="freight_company_name"
                                placeholder="Enter freight company name"  (focusout)="trimMe(freight_company_name)" />
                              <mat-error *ngIf="freight_company_name.invalid &&
                          ( freight_company_name.dirty || freight_company_name.touched )">
                                <span> Freight company name is required </span>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <!-- Message-TEXT-AREA-->
                    <div class="custom-form-group">
                      <label class="custom-label fx-display" for="">Order Notes </label>
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <textarea rows="5" cols="5" matInput formControlName="message"
                            placeholder="Enter order notes" (focusout)="trimMe(message)" ></textarea>
                          <mat-error *ngIf="message.invalid && ( message.dirty || message.touched )">
                            <span>Please provide a valid value</span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngFor="let singleNote of orderNotes" class="flex_order_notes">
                      <div class="custom-form-group">
                        <label for="" class="custom-label">Status:</label>
                        <p class="value">{{singleNote.status}}</p>
                      </div>
                      <div class="custom-form-group">
                        <label for="" class="custom-label">Message:</label>
                        <p class="value">{{singleNote.message}}</p>
                      </div>
                      <div class="custom-form-group" *ngIf="singleNote?.extra?.tracking_number">
                        <label for="" class="custom-label">Tracking Number:</label>
                        <p class="value">{{singleNote?.extra?.tracking_number}}</p>
                      </div>
                      <div class="custom-form-group" *ngIf="singleNote?.extra?.tracking_link">
                        <label for="" class="custom-label">Tracking Link:</label>
                        <p class="value">{{singleNote?.extra?.tracking_link}}</p>
                      </div>
                      <div class="custom-form-group" *ngIf="singleNote?.extra?.invoice">
                        <label for="" class="custom-label">Invoice:</label>
                        <p class="value">
                          <a [href]="singleNote?.extra?.invoice?.url" target="_blank">
                            <img src="../../../../../../../assets/images/icons/file_icon.svg" alt=""> Invoice
                          </a>
                          <!-- <img [src]="singleNote?.extra?.invoice?.url"
                          style="width:100px; height:100px" />  -->
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
        <!-- Modal-Footer -->
        <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button mat-button (click)="dialogClose('no')" class="modal-cancel-btn modal-footer-btn">
              <span>Cancel</span>
            </button>
            <button mat-button class="modal-save-btn global-btn modal-footer-btn">
              <span>Save</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
